<h2 mat-dialog-title>Historie</h2>

<mat-dialog-content>
    @if (!data.items?.length) {
        <p class="mat-text-disabled">Er is nog geen historie voor deze planning.</p>
    } @else {
        <div class="history-table-wrapper">
            <table class="table history-table">
                <colgroup>
                    <col class="col-date" />
                    <col class="col-user" />
                    <col class="col-source" />
                    <col class="col-field" />
                    <col class="col-old" />
                    <col class="col-new" />
                </colgroup>
                <thead>
                    <tr>
                        <th class="col-date">Datum</th>
                        <th class="col-user">Gebruiker</th>
                        <th class="col-source">Bron</th>
                        <th class="col-field">Veld</th>
                        <th class="col-old">Oud</th>
                        <th class="col-new">Nieuw</th>
                    </tr>
                </thead>
                <tbody>
                    @for (group of groups; track group) {
                        @let item = group.items[0];
                        @let source = item | sourceLabel: entities : users;
                        @let hasSource = item.source === 'user_planning' || source.kind !== null;

                        @let rowspan = group.expanded ? group.items.length : 1;
                        @let deleted = item.field === 'deleted_at';

                        @for (change of group.items; track change; let first = $first, last = $last) {
                            @if (first || group.expanded) {
                                <tr [class.history-subrow]="group.expanded && !last">
                                    @if (first) {
                                        <td class="fw-bold col-date text-end text-nowrap" [attr.rowspan]="rowspan">
                                            <span class="capitalized-date">{{
                                                change.created_at | date: dateFormat
                                            }}</span>
                                        </td>
                                        <td class="col-user" [attr.rowspan]="rowspan">
                                            <div class="text-truncate">
                                                {{ (users | byId: item.changed_by_id)?.name ?? 'Onbekend' }}
                                            </div>
                                        </td>
                                        @if (hasSource) {
                                            <td class="col-source" [attr.rowspan]="rowspan">
                                                <div
                                                    class="text-truncate"
                                                    [class.text-decoration-line-through]="deleted">
                                                    @if (item.source === 'user_planning') {
                                                        <i class="fa-regular fa-user"></i>
                                                        {{ (users | byId: item.user_id)?.name ?? 'Onbekend' }}
                                                    } @else if (source.kind === 'personnel') {
                                                        <i class="fa-regular fa-user"></i>
                                                        {{ source.name }}
                                                    } @else if (source.kind === 'materiel') {
                                                        <i class="fa-regular fa {{ source.icon }}"></i>
                                                        {{ source.name }}
                                                        @if (source.driverName) {
                                                            (<i class="fa-regular fa-user"></i> {{ source.driverName }})
                                                        }
                                                    }
                                                </div>
                                            </td>
                                        }
                                    }
                                    <td class="col-field" [attr.colspan]="hasSource ? null : 2">
                                        <div class="d-flex align-items-center gap-2">
                                            <span
                                                class="text-truncate"
                                                [class.text-decoration-line-through]="deleted && !hasSource">
                                                {{ getLabel(change) }}
                                            </span>
                                            @if (first && !group.expanded && group.items.length > 1) {
                                                <button
                                                    class="btn btn-link btn-sm p-0 text-nowrap"
                                                    type="button"
                                                    (click)="group.expanded = true">
                                                    +{{ group.items.length - 1 }}
                                                </button>
                                            }
                                        </div>
                                    </td>
                                    <td
                                        class="col-old text-decoration-line-through"
                                        [class.history-textarea]="isTextareaField(change.field)"
                                        [class.text-end]="isDateField(change)">
                                        @if (!deleted) {
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    value;
                                                    context: {
                                                        $implicit: change,
                                                        raw: change.old_value,
                                                        date: change.date_old_value,
                                                    }
                                                "></ng-container>
                                        }
                                    </td>
                                    <td
                                        class="col-new"
                                        [class.history-textarea]="isTextareaField(change.field)"
                                        [class.text-end]="isDateField(change)">
                                        @if (!deleted) {
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    value;
                                                    context: {
                                                        $implicit: change,
                                                        raw: change.new_value,
                                                        date: change.date_new_value,
                                                    }
                                                "></ng-container>
                                        }
                                    </td>
                                </tr>
                            }
                        }
                    }
                </tbody>
            </table>
        </div>
    }
</mat-dialog-content>

<ng-template #value let-change let-raw="raw" let-date="date">
    @if (isDateField(change)) {
        <span class="capitalized-date">{{ date ? (date | date: dateFormat) : '-' }}</span>
    } @else if (isCheckboxField(change.field)) {
        {{ raw === '1' || raw === 'true' ? 'Ja' : 'Nee' }}
    } @else if (!raw) {
        -
    } @else {
        @switch (idType(change.field)) {
            @case ('user') {
                {{ (users | byId: +raw)?.name ?? 'Onbekend' }}
            }
            @case ('entity') {
                {{ (entities | byId: +raw)?.name ?? 'Onbekend' }}
            }
            @case ('hiring') {
                {{ (hirings | byId: +raw)?.name ?? 'Onbekend' }}
            }
            @case ('person') {
                {{ (persons | byId: +raw)?.name ?? 'Onbekend' }}
            }
            @case ('customer') {
                {{ (customers | byId: raw : 'afas_customer_id')?.name ?? 'Onbekend' }}
            }
            @default {
                {{ raw }}
            }
        }
    }
</ng-template>

<mat-dialog-actions class="justify-content-end">
    <button mat-button mat-dialog-close>Sluiten</button>
</mat-dialog-actions>
